/**
 * Polyfills for modern JavaScript features
 * 为现代 JavaScript 特性提供 polyfill
 */

/**
 * Object.hasOwn polyfill
 * Object.hasOwn 是 ES2022 的特性，需要为旧浏览器提供兼容性支持
 * 
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwn
 */
if (!Object.hasOwn) {
  (Object as any).hasOwn = function (obj: object, prop: string | symbol): boolean {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

